import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import StockProduct from "../entities/stock/stockProduct";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class StockProductDB extends FirestorePipe {

  public static readonly colName = 'StockProducts'

  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${StockProductDB.colName}`);
  }

  public define(id: string, data: StockProduct): Promise<any> {
    return this._define(id, data);
  }
  public create(data: StockProduct): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: StockProduct): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<StockProduct[]> {
    return this._getAll<StockProduct>(...params);
  }
  public get(id: string): Promise<StockProduct> {
    return this._get(id);
  }
  public on(listener: (data: StockProduct[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default StockProductDB;